import { memo, useCallback } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { selectTokenBalance, useSelector } from '@bonanza-social/toolkit/state';
import { Box, PressableOverlay, Text } from '@bonanza-social/moonlight';
import { PrizeWallTokensInfoProps } from './PrizeWallTokensInfo.types';
import PrizeWallTokenIcon from '../PrizeWallTokenIcon/PrizeWallTokenIcon';

function PrizeWallTokensInfo(props: PrizeWallTokensInfoProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const tokenBalance = useSelector(selectTokenBalance);

  const onPress = useCallback(() => {
    navigation.navigate('PrizeWallCampaign', {
      screen: 'PrizeWallQuickRulesScreen',
    });
  }, [navigation]);

  return (
    <Box
      variant="outline-gradient"
      gradient="borderWarmUp"
      padding="space-025"
      borderRadius="radius-full"
      position="absolute"
      right="space-400"
      alignSelf="center"
      {...props}
    >
      <Box
        gap="space-100"
        flexDirection="row"
        paddingVertical="space-100"
        paddingHorizontal="space-200"
        backgroundColor="secondaryBackgroundHover"
        borderRadius="radius-full"
        alignItems="center"
      >
        <Text variant="body-m-semi" color="darkSurfacePrimary">
          {`${tokenBalance}`}
        </Text>
        <PrizeWallTokenIcon
          variant="small"
          width="space-400"
          height="space-400"
        />
      </Box>
      <PressableOverlay onPress={onPress} />
    </Box>
  );
}

export default memo(PrizeWallTokensInfo);
